import { Controller } from "@hotwired/stimulus"

const TEN_MINUTES = 10 * 60 * 1000

export default class extends Controller {
  static values = { url: String, updatedAt: String }

  // Lifecycle

  connect() {
    this.updatedAt ??= new Date()
    this.timer = setInterval(this.update, TEN_MINUTES)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  // Actions

  update = () => {
    if (document.hidden) return
    if (!this.hasUrlValue) return
    if (!this.needsUpdate) return
    this.element.src = this.urlValue
    this.updatedAt = new Date()
  }

  // Private

  get needsUpdate() {
    return this.updatedAgo >= TEN_MINUTES
  }

  get updatedAgo() {
    return new Date() - this.updatedAt
  }

  get updatedAt() {
    if (!this.updatedAtValue) return null
    return new Date(this.updatedAtValue)
  }

  set updatedAt(date) {
    this.updatedAtValue = date.toJSON()
  }
}
